module.exports = __webpack_public_path__ + "media/images/glyphs/logo-03e211f6e4d48f80fd1820a77b6c805e.svg";